import { makeStyles } from '@rbx/ui';
import styles from '@modules/ui/shared/utils/styles';
import {
  getAppMainTop,
  minSpecBannerHeight,
  rightNavPaddingX,
  rightNavPaddingXSmallMedium,
} from '@modules/layout/layout/constants/layoutConstants';

const useAppRightNavContentStyles = makeStyles<{
  showSecondaryNavigation: boolean;
  enableNewLayout: boolean;
}>()((theme, { showSecondaryNavigation, enableNewLayout }) => ({
  container: {
    position: 'sticky',
    top: minSpecBannerHeight,
    paddingLeft: rightNavPaddingX,
    [theme.breakpoints.down('Large')]: {
      paddingLeft: rightNavPaddingXSmallMedium,
    },
  },

  content: {
    // fades out when not interacted with
    opacity: 0.7,
    transition: 'opacity 0.1s ease-in-out',
    '&:hover, &:active, &:focus': {
      opacity: 1,
    },
  },

  emptyNode: {
    '& > div:first-child > div:first-child': {
      display: 'none',
    },
    '& > div:first-child > div:nth-child(2)': {
      display: 'none',
    },
  },

  title: {
    display: 'block',
    paddingTop: 8,
    paddingBottom: 8,
    marginBottom: 8,
    fontSize: 14,
    backgroundColor: theme.palette.surface[0],
    position: 'sticky',
    top: 0,
    marginLeft: enableNewLayout ? -40 : undefined,
  },

  tree: {
    ...styles.wordBreakWrap,
    width: 'calc(100% + 40px) !important',
    marginLeft: -40,
    overflowY: 'auto',
    maxHeight: `calc(100vh - ${getAppMainTop(showSecondaryNavigation)}px - 160px)`,
  },
}));

export default useAppRightNavContentStyles;
